import React from "react";
import styled, { css } from "styled-components";
import Menu from "components/bootstrap/Menu";
import { LinkContainer } from "components/common/router";
import { NavItem } from "components/bootstrap";
const DropdownOption = styled(Menu.Item)(
  ({ theme }) => css`
    font-family: ${theme.fonts.family.navigation};
    font-size: ${theme.fonts.size.navigation};

    &:hover,
    &:focus {
      color: inherit;
      text-decoration: none;
    }
  `
);
const NavigationLink = ({ Badge = void 0, description, path, topLevel = false, ...rest }) => {
  const title = Badge ? /* @__PURE__ */ React.createElement(Badge, { text: description }) : description;
  return /* @__PURE__ */ React.createElement(LinkContainer, { key: path, to: path, relativeActive: true, ...rest }, topLevel ? /* @__PURE__ */ React.createElement(NavItem, null, title) : /* @__PURE__ */ React.createElement(DropdownOption, { component: "a" }, title));
};
export default NavigationLink;
